export default __webpack_public_path__ + "static/media/cashflow_icon2.ab63f79a.svg";